import React from "react";
import { ResponseData } from "../../adminpanel/panels/types/types";

const Modal = ({ body }: ResponseData) => {
  if (body?.error) {
    return (
      <div className="flex justify-center">
        <div
          className={`w-13 h-1/12 z-50 fixed  content-center justify-self-center mx-auto bg-sk-primary-red animate-fade-in-down shadow-lg border rounded shadow-lg`}
        >
          <p className="text-lg font-bold text-white"> {body?.error} </p>
        </div>
      </div>
    );
  } else
    return (
      <div className="flex justify-center">
        <div
          className={`w-13 h-1/12 z-50 fixed flex justify-center content-center justify-self-center mx-auto bg-green-500 animate-fade-in-down shadow-lg border rounded shadow-lg`}
        >
          <p className="text-lg font-bold text-white"> {body?.message} </p>
        </div>
      </div>
    );
};
export default Modal;
